import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const SelectorsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
